<template>
    <LoadingSpinner v-if="loading" />
    <DxPopup v-model:visible="popup.visible"
             :title="popup.title"
             width="auto"
             height="auto"
             content-template="changeStatus">
        <template #changeStatus>
            <div class="puChangeStateMessage">
                Are you ready to send your profile?
                If yes, click on the button "OK" below.
            </div>
            <div class="puChangeStateButtons">
                <div class="puChangeStateButton">
                    <DxButton text="Cancel"
                              @click="popupChangeStateCancel"
                              type="default"></DxButton>
                </div>
                <div class="puChangeStateButton">
                    <DxButton text="OK"
                              @click="changeStateOnServer"
                              type="success"></DxButton>
                </div>
            </div>
        </template>
    </DxPopup>
    <div class="page-content">
        <div class="content">
            <h1 class="pqHeadFirst">Welcome to the AI Grid Platform</h1>
            <h2 class="pqHeadSec">Your application for the AI Grid Platform was accepted und approved. <br /></h2>
            <span class="pqHeadThird">This is your personal landing page. Edit your Profile, choose a Micro Focus Group and find a mentor.</span>
            <div class="icon-app">
                <div class="icon">
                    <img class="icon iconRew" v-bind:src="iconAccepted" />
                    <span class="iconAccepted">
                        Your application is accepted
                    </span>

                </div>
                <div class="line">
                    <div class="divider"></div>
                </div>
                <div class="icon">
                    <img :class="{icon:true , iconRew: StgId>12, iconPublished:StgId==15}" v-bind:src="iconRew" />
                    <span v-if="submitted==false " :class="{iconRew: StgId>12}">Publish your profile</span>
                    <span v-if="submitted==true" :class="{accepted:true , iconAccepted: StgId == 15}">Your profile is Published</span>
                </div>
            </div>
            <div class="tltProfilesContainer">
                <div class="tltCardContainer tltMfgs">
                    <div class="tltProfilesHeader">
                        <div class="tltProfilesHeaderCaption">
                            My Micro Focus Group
                        </div>
                    </div>
                    <DxGallery :data-source="mfgRequests"
                               :loop="false"
                               :slideshow-delay="false"
                               :show-indicator="mfgRequests.length>1"
                               :show-nav-buttons="false"
                               height="100%"
                               :width="380"
                               class="tltCardBox"
                               v-if="mfgRequests.length!=0 ">

                        <template #item="{ data}">
                            <div class="content">
                                <div class="tltCardBox gallery ">
                                    <div class="tltMfgTitle">
                                        {{ data.Title}}
                                    </div>
                                    <div class="tltMfgImageBox">
                                        <img class="tltMfgImage" :src="data.ImgUrl" alt="Image" />
                                    </div>

                                    <div class="tltActionStatus galleryBtn">
                                        <div class="tltActionButton tltContact">
                                            <div v-if="data.WfAccess.length>0" class="galleryBtns">
                                                <div v-for="acc in data.WfAccess" :class="{tltActionButton:acc.Access}" :key="acc.NextStatusId" @click="changeTopicLinkStatus(data.TopicId,data.TliId,acc.NextStatusId)">
                                                    <div v-if="acc.AssigneeAccess" class="tltActionIcon">
                                                        <i :class="acc.ActionButtonIcon"></i>  {{acc.ActionButtonText}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tltActionButton" @click="ViewMfg(data.TopicId)">
                                            <div class="tltActionIcon">
                                                <i class="fas fa-eye"></i>
                                            </div>
                                            <div class="tltActionLabel">
                                                View
                                            </div>
                                        </div>

                                        <div class="tltActionLabel">
                                            <div class="ltlMfgStatus">
                                                <div class="tltStatus">
                                                    <div class="tltStatusButton tltStatusWorkflowButton"> {{ data.StatusShortname }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </template>
                    </DxGallery>

                    <div v-else-if="!mfgRequests || mfgRequests.length == 0" class="tltCardBox tltCardBoxNone">
                        <div class="tltMfgNone">
                            No Micro Focus Group selected
                        </div>
                        <div class="tltMfgAction">
                            <DxButton type="success"
                                      icon="fa-light fa-paper-plane"
                                      @click="ApplyForMfg()"
                                      text="Choose a Micro Focus Group">
                            </DxButton>
                        </div>
                    </div>
                </div>
                <div class="tltCardContainer tltMfgs">
                    <div class="tltProfilesHeader">
                        <div class="tltProfilesHeaderCaption">
                            My Events
                        </div>
                    </div>
                    <DxGallery :data-source="events"
                               :loop="false"
                               :slideshow-delay="false"
                               :show-indicator="events.length>1"
                               :show-nav-buttons="false"
                               height="100%"
                               :width="380"
                               class="tltCardBox"
                               v-if="events.length!=0 ">

                        <template #item="{ data}">
                            <div class="content">
                                <div class="tltCardBox gallery event">
                                    <div class="tltMfgTitle">
                                        {{ data.TpcTitle}}
                                    </div>
                                    <div class="tltMfgImageBox">
                                        <img class="tltMfgImage" :src="data.ImgUrl" alt="Image" />
                                    </div>

                                    <div class="tltActionStatus galleryBtn">
                                        <div class="tltActionButton tltContact">
                                            <div class="galleryBtns" v-if="data.StatusList.length>0">
                                                <div v-for="acc in data.StatusList" :key="acc.StatusID" @click="changeTopicLinkStatus(data.TopicId,data.TliId,acc.StatusID)">
                                                    <div class="tltActionIcon">
                                                        <i :class="acc.ActionButtonIcon"></i>  {{acc.ActionButtonText}}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="tltActionButton" @click="ViewEvent(data.TopicId)">
                                            <div class="tltActionIcon">
                                                <i class="fas fa-eye"></i>
                                            </div>
                                            <div class="tltActionLabel">
                                                View
                                            </div>
                                        </div>

                                        <div class="tltActionLabel">
                                            <div class="ltlMfgStatus">
                                                <div class="tltStatus">
                                                    <div class="tltStatusButton tltStatusWorkflowButton"> {{ data.StatusShortname }}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </template>
                    </DxGallery>

                    <div v-else-if="!events || events.length == 0" class="tltCardBox tltCardBoxNone">
                        <div class="tltMfgNone">
                            Not participating in any event
                        </div>
                        <div class="tltMfgAction">
                            <DxButton type="success"
                                      icon="fa-light fa-paper-plane"
                                      @click="RegisterForEvent()"
                                      text="Attend an Event">
                            </DxButton>
                        </div>
                    </div>
                </div>
                <div class="tltCardContainer tltMyProfile">
                    <div class="tltProfilesHeader">
                        <div class="tltProfilesHeaderCaption">
                            My Profile
                        </div>
                        <div class="tltProfilesHeaderAction">

                        </div>
                    </div>
                    <div v-for="profile in myProfiles" :key="profile.TopicId" class="tltCardBox">
                        <div class="tltProfileBox">
                            <div class="tltStatus">
                                <div v-if="profile.IsAmbassador" class="tltStatusButtonAmbassador">Ambassador</div>
                                <div v-else class="tltStatusButton">Member</div>
                            </div>
                            <div class="tltName">
                                {{ profile.UsrFirstName }}<br />{{ profile.UsrLastName }}
                            </div>
                            <div class="tltSocialMediaLinks">
                                <div :class="{tltLinkButton:true, hasSocialmedia:profile.UsrAccountLinkedIn > ''}">
                                    <a v-if="profile.UsrAccountLinkedIn" :href="profile.UsrAccountLinkedIn" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
                                    <i v-else class="fa-brands fa-linkedin"></i>
                                </div>
                                <div :class="{tltLinkButton:true, hasSocialmedia:profile.ContactViaSlack > ''}">
                                    <a v-if="profile.ContactViaSlack" href="https://aigrid.slack.com/" target="_blank"> <i class="fa-brands fa-slack"></i></a>
                                    <i v-else class="fa-brands fa-slack"></i>
                                </div>
                                <div :class="{tltLinkButton:true, hasSocialmedia:profile.UsrEMail > ''}">
                                    <a v-if="profile.UsrEMail" :href="'mailto:'+ profile.UsrEMail" target="_blank"> <i class="fas fa-envelope"></i></a>
                                    <i v-else class="fas fa-envelope"></i>
                                </div>
                            </div>
                            <div class="tltPhoto">
                                <img :src="profile.ProfilePhoto" alt="ProfilePhoto" class="tltProfilePhoto" />


                            </div>
                            <div class="tltDevider"></div>
                            <div class="tltFields">
                                <div class="tltFieldLabel">Fields of Research in AI</div>
                                <span class="tltFiledValues" v-for="(field, i) in profile.FieldOfResearch" v-bind:key="field.LitId">
                                    <span v-if="i > 0">, </span><span :title="field.LitName">{{ field.LitShortName }}</span>
                                </span>
                            </div>
                            <div class="tltMfgs">
                                <div class="tltMfgLabel">Micro Focus Group</div>
                                <div v-for="topic in profile.MfgList.filter(m => m.StgId == 15)" :key="topic.TopicId" class="tltLinkItem">
                                    <div class="tltMfgLinkTemplate" @click="openLinkedDetail(topic.TopicId)">
                                        {{ topic.Title }}
                                    </div>
                                </div>
                                <div v-if="profile.MfgList.filter(m => m.StgId == 15).length == 0" class="tltLinkItem">
                                    <div class="tltMfgNoneSelected">
                                        No Micro Focus Group Selected
                                    </div>
                                </div>
                            </div>

                            <div class="tltAction">
                                <div @click="EditApp" v-if="writeAccess" class="tltActionButton">
                                    <div class="tltActionIcon">
                                        <i class="fa-regular fa-gear"></i>
                                    </div>
                                    <div class="tltActionLabel">
                                        Edit
                                    </div>
                                </div>
                                <div @click="ViewApp" v-else class="tltActionButton">
                                    <div class="tltActionIcon">
                                        <i class="fas fa-eye"></i>
                                    </div>
                                    <div class="tltActionLabel">
                                        View
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tltCardContainer tltMyMentor">
                    <div class="tltProfilesHeader">
                        <div class="tltProfilesHeaderCaption">
                            My Mentors
                        </div>
                        <div class="tltProfilesHeaderAction ">
                            <span v-if=" mentorList.length!= 0" @click="ApplyForMentor()">
                                <i class="fa-light fa-plus addnew">

                                </i>
                            </span>

                        </div>
                    </div>
                    <DxGallery :data-source="mentorList"
                               :loop="false"
                               :slideshow-delay="false"
                               :show-nav-buttons="false"
                               :width="380"
                               height="100%"
                               class="tltCardBox"
                               :show-indicator="mentorList.length>1"
                               v-if="mentorList.length ">

                        <template #item="{ data}">
                            <div class="content">
                                <div class="tltCardBox gallery">
                                    <div class="tltProfileBox">
                                        <div class="tltStatus">
                                            <div v-if="data.IsAmbassador" class="tltStatusButtonAmbassador">Ambassador</div>
                                            <div v-else class="tltStatusButton tltStatusMentorButton">Mentor</div>
                                        </div>
                                        <div class="tltName">
                                            {{ data.UsrFirstName }}<br />{{ data.UsrLastName }}
                                        </div>
                                        <div class="tltSocialMediaLinks">
                                            <div :class="{tltLinkButton:true, hasSocialmedia:data.UsrAccountLinkedIn > ''}">
                                                <a v-if="data.UsrAccountLinkedIn" :href="data.UsrAccountLinkedIn" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
                                                <i v-else class="fa-brands fa-linkedin"></i>
                                            </div>
                                            <div :class="{tltLinkButton:true, hasSocialmedia:data.ContactViaSlack > ''}">
                                                <a v-if="data.ContactViaSlack" href="https://aigrid.slack.com/" target="_blank"> <i class="fa-brands fa-slack"></i></a>
                                                <i v-else class="fa-brands fa-slack"></i>
                                            </div>
                                            <div :class="{tltLinkButton:true, hasSocialmedia:data.UsrEMail > ''}">
                                                <a v-if="data.UsrEMail" :href="'mailto:'+ data.UsrEMail" target="_blank"> <i class="fas fa-envelope"></i></a>
                                                <i v-else class="fas fa-envelope"></i>
                                            </div>
                                        </div>
                                        <div class="tltPhoto">
                                            <img :src="data.ProfilePhoto" alt="ProfilePhoto" class="tltProfilePhoto" />

                                        </div>
                                        <div class="tltDevider"></div>
                                        <div class="tltFields">
                                            <div class="tltFieldLabel">Fields of Research in AI</div>
                                            <span class="tltFiledValues" v-for="(field, i) in data.FieldOfResearch" v-bind:key="field.TopicId">
                                                <span v-if="i > 0">, </span><span>{{ field.LitShortName }}</span>
                                            </span>
                                        </div>
                                        <div class="tltMfgs">
                                            <div class="tltMfgLabel">Micro Focus Group</div>
                                            <div v-for="topic in data.MfgList.filter(m => m.StgId == 15)" :key="topic.TopicId" class="tltLinkItem">
                                                <div class="tltMfgLinkTemplate">
                                                    {{ topic.Title }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="tltAction">
                                            <div @click="ViewAppOthermember(data.TopicId)" class="tltActionButton">
                                                <div class="tltActionIcon">
                                                    <i class="fas fa-eye"></i>
                                                </div>
                                                <div class="tltActionLabel">
                                                    View
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </DxGallery>
                    <div v-else class="tltCardBox tltCardBoxNone">
                        <div class="tltMentorNone">
                            No Mentor selected
                        </div>
                        <div class="tltMentorAction">
                            <DxButton type="success"
                                      icon="fa-light fa-paper-plane"
                                      @click="ApplyForMentor()"
                                      text="Find a Mentor">
                            </DxButton>
                        </div>
                    </div>
                </div>
                <div class="tltCardContainer tltMyMentor">
                    <div class="tltProfilesHeader">
                        <div class="tltProfilesHeaderCaption">
                            Offered / Requested Mentoring
                        </div>
                    </div>
                    <DxGallery id="gallery"
                               v-if="mentorRequests.length != 0"
                               :data-source="mentorRequests"
                               :loop="false"
                               :slideshow-delay="false"
                               :show-nav-buttons="false"
                               :show-indicator="mentorRequests.length>1"
                               height="100%"
                               :width="380"
                               class="tltCardBox">

                        <template #item="{ data }">

                            <div class="content">

                                <div class="tltCardBox gallery">
                                    <div class="tltProfileBox">
                                        <div class="tltStatus">
                                            <div v-if="data.IsAmbassador" class="tltStatusButtonAmbassador">Ambassador</div>
                                            <div v-else class="tltStatusButton tltStatusMentorButton">Mentor</div>
                                        </div>
                                        <div class="tltName">

                                            {{ data.UsrFirstName }}<br />{{ data.UsrLastName }}
                                        </div>
                                        <div class="tltSocialMediaLinks">
                                            <div :class="{tltLinkButton:true, hasSocialmedia:data.UsrAccountLinkedIn > ''}">
                                                <a v-if="data.UsrAccountLinkedIn" :href="data.UsrAccountLinkedIn" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
                                                <i v-else class="fa-brands fa-linkedin"></i>
                                            </div>
                                            <div :class="{tltLinkButton:true, hasSocialmedia:data.ContactViaSlack > ''}">
                                                <a v-if="data.ContactViaSlack" href="https://aigrid.slack.com/" target="_blank"> <i class="fa-brands fa-slack"></i></a>
                                                <i v-else class="fa-brands fa-slack"></i>
                                            </div>
                                            <div :class="{tltLinkButton:true, hasSocialmedia:data.UsrEMail > ''}">
                                                <a v-if="data.UsrEMail" :href="'mailto:'+ data.UsrEMail" target="_blank"> <i class="fas fa-envelope"></i></a>
                                                <i v-else class="fas fa-envelope"></i>
                                            </div>
                                        </div>
                                        <div class="tltPhoto">
                                            <img :src="data.ProfilePhoto" alt="ProfilePhoto" class="tltProfilePhoto" />

                                        </div>
                                        <div class="tltDevider"></div>
                                        <div class="tltFields">
                                            <div class="tltFieldLabel">Fields of Research in AI</div>
                                            <span class="tltFiledValues" v-for="(field, i) in data.FieldOfResearch" v-bind:key="field.LitId">
                                                <span v-if="i > 0">, </span><span :title="field.LitName">{{ field.LitShortName }}</span>
                                            </span>
                                        </div>
                                        <div class="tltMfgs">
                                            <div class="tltMfgLabel">Micro Focus Group</div>

                                            <div v-for="mfg in data.MfgList.filter(m => m.StgId == 15)" :key="mfg.TopicId" class="tltLinkItem">
                                                <div class="tltMfgLinkTemplate">
                                                    {{ mfg.Title }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tltActionButtonProfile tltContact" v-if="data.WfAccess.length && data.StgId==1">
                                            <div v-for="acc in data.WfAccess" :class="{tltActionButton:acc.Access}" :key="acc.NextStatusId" @click="changeTopicLinkStatus(data.TopicId,data.TliId,acc.NextStatusId)">
                                                <div v-if="acc.AssigneeAccess" class="tltActionIcon">
                                                    <i :class="acc.ActionButtonIcon"></i>  {{acc.ActionButtonText}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tltAction">
                                            <div class="tltActionButton" @click="ViewAppOthermember(data.TopicId)">
                                                <div class="tltActionIcon">
                                                    <i class="fas fa-eye"></i>
                                                </div>
                                                <div class="tltActionLabel">
                                                    View
                                                </div>
                                            </div>
                                            <div v-if="(!data.IsLinkAssignee && data.StgId!=1) || data" class="tltActionStatus">
                                                <div class="tltActionLabel">
                                                    <div class="ltlMfgStatus">
                                                        <div class="tltStatus">
                                                            <div class="tltStatusButton tltStatusWorkflowButton"> {{ data.StatusShortname }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>

                        </template>
                    </DxGallery>
                    <div class="tltCardBox tltCardBoxNone tltMyMentor" v-else>
                        <div class="tltMentorNone">
                            No open request for mentoring
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="img-bg">
            <div class="bg-image-sq">
                <img class="bg-image" v-bind:src="bgSq" />
            </div>
        </div>

    </div>

</template>
<script>
    import moment from "moment";
    import LoadingSpinner from "@/views/widgets/LoadingSpinner"
    import { DxButton } from 'devextreme-vue/button';
    import axios from "axios";
    import { DxPopup } from 'devextreme-vue/popup';
    import DxGallery from 'devextreme-vue/gallery';
    import $ from 'jquery';
    const baseUri = "WebApi.asmx/api/application";
    export default {

        name: 'ProfileStatus',
        components: {
            DxButton,
            DxPopup,
            DxGallery,
            LoadingSpinner
        },
        data() {
            return {
                popup: {
                    visible: false,
                    title: "Confirm Submission"
                },
                loading: false,
                moment: moment,
                showContact: false,
                topicLinkList: [],
                events: [],
                event: [],
                myProfiles: [],
                mentorList: [],
                ambassador: [],
                mentorListTliID: [],
                mfgRequests: [],
                mentorRequests: [],
                showLinkStatusInfo: true,
                writeAccess: false,
                readAccess: false,
                submitted: false,
                post: null,
                fullfill: 0,
                missingFields: [],
                missed: 0,
                TopicId: 0,
                StatusId: 0,
                StgId: 0,
                //iconRew: "~/Images/221219_AI-Grid_Icon_Application.svg",
                //iconFeed: "~/Images/221219_AI-Grid_Icon_Invitation.svg",
                iconSent: "~/Images/230112_AI-Grid_Icon_Sent.svg",
                bgSq: "",
                iconAccepted: "~/Images/230112_AI-Grid_Icon_Accepted.svg",
                iconDeclined: "~/Images/230112_AI-Grid_Icon_Declined.svg",
                logoBmbf: "~/Images/Logo_BMBF_en.svg",
            }
        },
        computed: {
            mfgList() {
                var result = this.$store.state.topicLinkStore.mfgList.filter(m => m.StgId >= 10 && m.StgId < 20);
                return result
            },
            iconRew() {

                return "~/Images/230323_AI-Grid_Icon_Profile.svg"
            },
            iconFeed() {

                return "~/Images/230112_AI-Grid_Icon_Feedback.svg"
            },
        },
        created: function () {
            this.GetApplicationStatus();
            this.GetMfgList();
        },
        methods: {
            GetMfgList() {
                return this.$store.dispatch("getMfgList", {})
            },
            loadTopicLinkListEx() {
                return this.$store.dispatch("getTopicLinkListEx", { topicId: this.post.topic.TopicId, withPhoto: true }).then((res) => {
                    var list = res.data.topicLinkList;
                    this.topicLinkList = list && list.TopicList1 ? (list.TopicList1 ? list.TopicList1.concat(list.TopicList2) : list.TopicList2) : [];
                    if (this.topicLinkList.length > 0) {
                        this.event = this.topicLinkList.filter(m => m.TltId == 5);
                        if (this.event.length > 0)
                            this.events = this.event[0].Topics;
                    }
                })
            },
            loadMyAiGridProfiles() {
                return this.$store.dispatch("getMyAiGridProfiles", { ttyId: 22 }).then((res) => {
                    this.mfgList.forEach(f => {
                        if (f.TpcHasAmbassedor) {
                            this.ambassador.push(f.AmbassadorId);
                        }
                    })
                    this.myProfiles = res.data.profiles;
                    this.myProfil = this.myProfiles[0];

                    this.mentorList = this.myProfiles[0].MentorList.filter(m => m.StgId == 15);


                    this.mfgRequests = this.myProfiles[0].MfgList;

                    this.mentorRequests = this.myProfiles[0].MentorList.filter(m => m.StgId != 15);

                })
            },
            loadTopicAccess() {
                this.$store.dispatch("getTopicAccess", { args: this.args, topicId: this.post.topic.TopicId }).then(res2 => {
                    this.writeAccess = res2.access.Update;
                    this.readAccess = res2.access.Open;
                    this.TopicId = this.post.topic.TopicId;
                    this.StatusId = this.post.topic.StatusId;
                    this.fullfill = this.post.topic.TpcFullfillment2;
                    this.submitted = this.post.topic.IsSubmitted;
                    this.StgId = this.post.topic.StgId;
                    this.StatusId = this.post.topic.StatusId;
                    this.missingFields = this.post.missingFields2;
                    this.missed = this.missingFields.length;
                    var bar = document.getElementById("filledBar");
                    var barGrey = document.getElementById("filledBarGrey");
                    this.fullfill = this.fullfill ? this.fullfill : 0;
                    if (bar && barGrey) {
                        bar.style.width = this.fullfill + '%';
                        barGrey.style.width = 100 - this.fullfill + '%';
                        if (this.fullfill == 100) {
                            bar.style.borderRadius = "10px";
                        }
                        if (this.fullfill == 0)
                            barGrey.style.borderRadius = "10px";
                    }
                })
            },
            GetApplicationStatus() {
                this.loading = true;
                return axios.get(baseUri + '/GetApplicationStatus')
                    .then(res => {
                        this.post = res.data;
                        if (this.post.canCreateNew && this.post.hasTopic == false) {
                            window.location.href = "IdeaApplicationCreateDx.aspx";
                            return
                        }
                        if (this.post.topic) {
                            Promise.all([
                                this.loadTopicLinkListEx(),
                                this.loadMyAiGridProfiles(),
                                this.loadTopicAccess()
                            ]).then(() => {
                                this.loading = false;
                            });
                        }
                        else {
                            this.writeAccess = false;
                            this.readAccess = false;
                            this.fullfill = 0;
                        }
                        this.popup.visible = false;
                        return res;
                    })
            },
            ChangeStatus(statusId) {
                this.popup.visible = true;
                this.popup.statusId = statusId;
            },
            changeStateOnServer() {
                this.$store.dispatch("SubmitApplication", { topicId: this.TopicId, statusId: this.popup.statusId, fullfillmentNo: 2, submitToast: "Your application was successfully published" }).then((res) => {
                    if (res.data.success) {
                        this.submitted = true;
                        this.GetApplicationStatus();
                        return;
                    }
                });
                this.popup.visible = false;
            },
            popupChangeStateCancel() {
                this.popup.visible = false;
            },
            EditApp() {
                $("form").attr("action", window.location.pathname + "?action=edit&topicId=" + this.TopicId).submit()
            },
            ViewApp() {
                $("form").attr("action", window.location.pathname + "?action=view&topicId=" + this.TopicId).submit()
            },
            ViewAppOthermember(topicId) {
                $("form").attr("action", window.location.pathname + "?action=view&topicId=" + topicId).submit()
            },
            ViewEvent(topicId) {
                $("form").attr("action", window.location.pathname + "?action=viewEvent&topicId=" + topicId).submit()
            },
            ViewMfg(topicId) {
                $("form").attr("action", window.location.pathname + "?action=viewMfg&topicId=" + topicId).submit()
            },
            changeTopicLinkStatus(topicId, tliId, statusId) {
                this.loading = true
                this.$store.dispatch("changeTopicLinkStatus", { topicId, statusId, tliId }).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.loadTopicLinkListEx();
                        this.loadMyAiGridProfiles();
                    }
                })
            },
            contact(profile) {
                var elem = document.getElementById(profile.TopicId);

                if (elem.className == "shrinkedContacts") {
                    elem.className = "expandContacts";
                    elem.parentElement.classList.add("expand");
                }

                else {
                    elem.className = "shrinkedContacts";
                    elem.parentElement.classList.remove("expand");
                }

            },
            ApplyForMfg() {
                $("form").attr("action", window.location.pathname + "?action=openMfgSelectionParticipant").submit()
            },
            RegisterForEvent() {
                $("form").attr("action", window.location.pathname + "?action=registerForEvent&topicId=" + this.TopicId).submit()
            },
            ApplyForMentor() {
                $("form").attr("action", window.location.pathname + "?action=applyForMentor&topicId=" + this.TopicId).submit()
            },
        }
    }
</script>
<style scoped>
    .tltMfgs .tltCardBox.gallery {
        height: 100%
    }

    .tltActionIcon {
        cursor: pointer;
    }

    .tltActionStatus.galleryBtn {
        display: grid;
        grid-template-columns: 3fr 1fr 1fr;
        grid-auto-flow: column;
        padding-bottom: 10px;
    }

    .galleryBtns {
        display: grid;
        grid-auto-flow: column;
        column-gap: 10px;
        color: #ea733b;
    }

    .tltProfileBox .tltActionButtonProfile {
        column-gap: 20px;
    }



    .tltMfgImageBox {
        height: inherit;
    }

    .fields {
        padding-top: 25px;
    }

        .fields ul {
            font-weight: normal;
            padding: 0px;
        }

    #app li {
        padding-bottom: 15px;
        margin-left: 0px;
        list-style-type: none;
    }

    img.icon {
        opacity: 0.3;
    }

    .progress span {
        color: var(--bg-color1);
        font-weight: bold;
    }

    img.icon.iconPublished {
        opacity: 1;
        display: unset;
    }

    img.iconProfile.icon, img.iconRew.icon, img.iconRew.icon {
        opacity: 1;
    }

    span.iconFeed, span.accepted {
        display: none;
    }

    span.iconAccepted {
        display: unset;
    }

    span.iconProfile, span.iconRew, span.iconAccepted {
        color: #313741;
    }

    .divider {
        display: inline-block;
        border-bottom: #999999 1px solid;
        width: 70px;
        color: #999999;
        vertical-align: middle;
    }

    .line {
        align-items: center;
        margin-bottom: 40px;
    }

    .register {
        margin-top: 10px;
        font-size: 15px;
        font-weight: bold;
        color: white;
        text-align: center;
    }

    .icon-app {
        margin-bottom: -5px;
        max-width: 600px;
        display: grid;
        grid-template-columns: 20% 20% 20% 20% 20%;
        column-gap: 5px;
        padding: 60px 45px 20px 0px;
    }

    div.icon-app > div {
        display: grid;
        font-size: 15px;
        color: #a3a3a3;
        font-weight: bold;
        grid-row-gap: 12px;
        text-align: center;
        justify-items: center;
    }

    .lgi-btns {
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        column-gap: 20px;
        row-gap: 10px;
    }

    .missing-fields {
        padding-top: 30px;
        display: grid;
        grid-row-gap: 15px;
    }

        .missing-fields span {
            color: #465a64;
        }

        .missing-fields div {
            color: #465a64;
            font-size: 15px;
            font-weight: bold;
        }

    span.grey-text {
        font-size: 15px;
        margin: 0px 20px 0px 20px;
        color: #a3a3a3;
        font-weight: bold;
    }

    img.icon {
        /*padding-right: 45px;*/
    }


    h4, h3 {
        color: #465a64;
        font-size: 17px;
        font-weight: lighter;
    }

    h4 {
        margin: 0px 0px 10px 0px;
        max-width: 90%;
    }

    h3.head-forth {
        color: #00a4e0;
        margin: 35px 0px 15px 0px;
        font-size: 17px;
        font-weight: bold;
    }

    h3.head-third {
        margin: 35px 0px 10px 0px;
        font-weight: bold;
    }



    .page-content {
        width: 100%;
        display: grid;
        grid-template-columns: auto auto;
        margin: 10px 0px 10px 0px;
    }

    .progress {
        display: flex;
        column-gap: 10px;
        padding-top: 15px;
    }

    .progress-bar {
        border-width: 0px;
        border-radius: 10px;
        height: 20px;
        width: 500px;
    }

    .filled-bar {
        background-color: #ec9b4d;
        width: 0%;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        height: 20px;
        position: absolute;
    }

    .fullfill {
        position: relative;
    }

    .tltMentorAction {
        justify-self: center;
    }

    div.missing-fields div.fullfill div.fullfill-percent {
        position: absolute;
        font-size: 12px;
        height: 20px;
        margin-top: 3px;
        color: #465a64;
        margin-left: 50%;
        font-weight: normal;
    }

    .tltActionStatus {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        gap: 10px;
    }

        .tltActionStatus .tltActionButton {
            cursor: pointer;
            display: flex;
            gap: 5px;
            color: #00a4e0;
        }


    .filled-bar-grey {
        background-color: #ebebeb;
        width: 100%;
        float: right;
        color: white;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        height: 20px;
    }
    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        span.dx-button-text {
            display: unset;
        }

        .line {
            margin-bottom: unset;
        }

        .progress-bar {
            width: 100%;
        }

        .progress {
            display: flex;
            flex-direction: column;
            justify-self: center;
            width: 100%;
        }

        .missing-fields, .missing-fields div {
            text-align: center;
        }

        .page-content {
            margin: 10px 0px 10px 0px;
        }

        .content {
            text-align: center;
        }

        .img-bg {
            display: none;
        }

        .img-icon {
            padding: 0;
        }

        .icon-app {
            display: flex;
            flex-direction: column;
            justify-items: center;
            padding: 0;
            gap: 20px;
        }

        h3.head-forth {
            text-align: center;
        }

        div.icon-app > div {
            justify-items: center;
            text-align: center;
        }

        .lgi-btns {
            padding-top: 30px;
            padding-right: 0;
            padding-left: 0;
            flex-direction: column;
        }

            .lgi-btns .dx-button {
                width: auto !important;
            }

        span.grey-text {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }
</style>